import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import {
  parseCsvCalendarDate,
  parseCsvLocalDateTime,
  parseEnumEmptyString,
  parseBooleanValue,
} from '~/prix/utils/bulk/csvValueParsers'

const residenceProfile: Dataset = {
  schema: 'public_health',
  table: 'residence_profile',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    residence_code: original => original,
    housing_situation: original => parseEnumEmptyString(original as string),
    location_type: original => parseEnumEmptyString(original as string),
    house_type: original => parseEnumEmptyString(original as string),
    house_access_type: original => parseEnumEmptyString(original as string),
    garbage_disposal_type: original => parseEnumEmptyString(original as string),
    water_treatment_type: original => parseEnumEmptyString(original as string),
    land_possession_type: original => parseEnumEmptyString(original as string),
    wall_material_type: original => parseEnumEmptyString(original as string),
    water_supply_type: original => parseEnumEmptyString(original as string),
    sanitation_type: original => parseEnumEmptyString(original as string),
    has_electricity: original => parseBooleanValue(original as string),
    has_animal: original => parseBooleanValue(original as string),
    has_cat: original => parseBooleanValue(original as string),
    has_dog: original => parseBooleanValue(original as string),
    has_bird: original => parseBooleanValue(original as string),
    has_other_animals: original => parseBooleanValue(original as string),
    has_other_professionals_attached: original => parseBooleanValue(original as string),
    resident_count: original => (original ? Number(original) : null),
    room_count: original => (original ? Number(original) : null),
    has_registration_refusal: original => parseBooleanValue(original as string),
    property_type: original => parseEnumEmptyString(original as string),
    date: original => parseCsvCalendarDate(original as string),
    cbo: original => parseEnumEmptyString(original as string),
    animal_count: original => original,
    micro_area: original => original,
    street_name: original => original,
    street_number: original => original,
    street_type: original => original,
    complement: original => original,
    neighborhood: original => original,
    reference_point: original => original,
    postal_code: original => original,
    municipality: original => original,
    state: original => original,
    home_phone: original => original,
    contact_phone: original => original,
    professional_cns: original => original,
    professional_cbo: original => original,
    professional_cnes: original => original,
    professional_ine: original => original,
    created_at: original => parseCsvLocalDateTime(original as string),
    updated_at: original => parseCsvLocalDateTime(original as string),
  },
}

export default residenceProfile
